import APIs from "../../apiUrl";

const BrandsService = {
  getAllBrands: async ({ page = 1, limit = 10 }) => {
    try {
      const response = await APIs.get(`/get_all_brand/${page}/${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
 
  getSingleBrand: async (payload) => {
    try {
      if (!payload?.Id) {
        console.error("Missing brand ID in getSingleBrand");
        throw new Error("Brand ID is required");
      }
      
      const response = await APIs.get(`/get_single_brand/${payload?.Id}`);
      
      if (response?.data?.message === 'success') {
        return response?.data;
      }
      
      return response.data;
    } catch (error) {
      console.error("Error in getSingleBrand service:", error);
      throw error;
    }
  },
  
  getProductsByBrand: async ({ brandName, page = 0, limit = 10 }) => {
    try {
      console.log(`Fetching products for brand: ${brandName}, page: ${page}, limit: ${limit}`);
      
      // Use the search endpoint with brand parameter
      const response = await APIs.get(`/search?brand=${encodeURIComponent(brandName)}&page=${page}&limit=${limit}`);
      console.log("Products by brand response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching products by brand:", error);
      throw error;
    }
  }
};

export default BrandsService;
